import { createSelector } from '@reduxjs/toolkit'

import { IEventData } from 'meta/pages/v4/event'
import { RootState, SliceSelector } from 'store/types'

const _getState = (state: RootState) => state.pages.event

const getVisibleEventFeesCodeUrl = createSelector(_getState, (state) => state.fees.visibleEventCodeUrl)

const getVisibleEventFees = createSelector(
  [getVisibleEventFeesCodeUrl, (state) => _getState(state).fees.events],
  (codeUrl, eventFees) => (codeUrl ? eventFees[codeUrl] : undefined)
)

const getVisibleEventGoodsCodeUrl = createSelector(_getState, (state) => state.goods.visibleEventCodeUrl)

const getVisibleEventGoods = createSelector(
  [getVisibleEventGoodsCodeUrl, (state) => _getState(state).goods.events],
  (codeUrl, eventGoods) => (codeUrl ? eventGoods[codeUrl] : undefined)
)

const getEventMetadata = createSelector(_getState, (state) => state.metadata)

const getEventData: SliceSelector<IEventData | undefined, { idOrCodeUrl: string }> =
  ({ idOrCodeUrl }) =>
  (state) =>
    state.pages.event.data.events[idOrCodeUrl]

const getEventBulkData: SliceSelector<IEventData[] | undefined, { idsOrCodeUrls: string[] }> =
  ({ idsOrCodeUrls }) =>
  (state) => {
    return idsOrCodeUrls.map((idOrCode) => state.pages.event.data.events[idOrCode]).filter(Boolean) as IEventData[]
  }

const getLocationsIdsFromBulkEventIds: SliceSelector<number[] | undefined, { eventIdsKey: string }> =
  ({ eventIdsKey }) =>
  (state) =>
    state.pages.event.data.bulk.locationIds[eventIdsKey]

export const EventSelectors = {
  getVisibleEventFeesCodeUrl,
  getVisibleEventFees,
  getVisibleEventGoodsCodeUrl,
  getVisibleEventGoods,
  getEventMetadata,
  getEventData,
  getEventBulkData,
  getLocationsIdsFromBulkEventIds,
}
